import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function Papers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const papersList = [
    { id: 12, title: "Learning from the Margins: Intra-Class Graph Structure for Fair Deep Models" },
    { id: 15, title: "Continuum Removal Based Subspace Stamped Feature Extraction Technique for Spectral Matching and Hyperspectral Image Analysis" },
    { id: 21, title: "Smart Infrared Monitoring System for High and Low Busbar Loads" },
    { id: 36, title: "Andha-Dhun: A First Look at Audio Descriptions in Hindi" },
    { id: 41, title: "Automated Plantation Monitoring Using Drone Images: A Dataset and Model Performance Review" },
    { id: 42, title: "Hybrid Sensitivity-Aware Filter Pruning for Fair Dermatological Diagnosis" },
    { id: 45, title: "Detection of Virus and Small Cell Patches in Foci Images Using Switchable Convolution and Feature Pyramid Network" },
    { id: 55, title: "Vision Transformer Based Framework for Robust Detection of Atrial Fibrillation from ECG Signals" },
    { id: 60, title: "Multi Label Knowledge Distillation of Compound Expression using Multi-Task Learning" },
    { id: 63, title: "NeuroSymbEAD: A Large Scale Neuro-Symbolic Caption Dataset for Omni-Directional Embodied Autonomous Driving" },
    { id: 64, title: "Lightweight Shared Gating for Robust Vision Transformers on Small Datasets" },
    { id: 66, title: "FADER: Frequency ADaptive implicit nEuRal representations" },
    { id: 73, title: "Multi-modal Cattle Verification Using Vision Transformers and Cross-Attention Refinement" },
    { id: 76, title: "Edge-Based Real-Time Weapon Detection Using Deep Learning for Urban Surveillance" },
    { id: 77, title: "Adversarial Source-Free Domain Adaptation for Fundus Image Segmentation" },
    { id: 79, title: "An Attention-Based Denoising Model for Diffusion Weighted Imaging" },
    { id: 84, title: "CFA Attention-Guided Network for Detecting AI Generated Forged Societal Sensitive Images" },
    { id: 92, title: "Safety-First Bilevel Direct Preference Optimization for Diffusion Model Alignment with LoRA" },
    { id: 94, title: "MambaNext: A Context-Aware Hybrid CNN-SSM for Efficient Medical Image Classification" },
    { id: 107, title: "Geometry-Preserving Contrastive Learning with Dual-Level Style Augmentation for Cross-Geographic Domain Generalization in Aerial Object Detection" },
    { id: 110, title: "CDVTH: Contrastive Dual Vision Transformer Hashing for Unsupervised Image Retrieval" },
    { id: 115, title: "SST-AL: A Spectral-Spatial Transformer based Active Learning framework for Forensic Hyperspectral Bloodstain Classification" },
    { id: 117, title: "SAM-3 Based Semantic Segmentation for Aerial Images with Limited Annotations: A Prototype-Guided Patch Classification Approach" },
    { id: 121, title: "Perceptual Regularisation from Human Visual System Models Improves Adversarial Robustness" },
    { id: 139, title: "SmartConsult: A Low-Cost Smartphone Driven Real Time VR Tele-Consultation System for Clinician-Patient Interaction" },
    { id: 155, title: "Weak Attention Preservation Block in Vision Transformer for Single Image De-raining" },
    { id: 161, title: "UniSR: A Unified Multi-Modal Super-Resolution Architecture with Domain-Adaptive Routing for Medical and Satellite Images" },
    { id: 163, title: "Beyond Visual Realism: A Comparative Study of Generative Models for Hindi Handwritten Text Generation" },
    { id: 179, title: "Regime-Aware Portfolio Allocation Using Latent Representations and a Soft Transition Mechanism" },
    { id: 184, title: "DepthNet-Sparse" },
    { id: 193, title: "Distribution-Aware Contrastive Learning Framework for Unsupervised Accident Classification" },
    { id: 194, title: "Real-Time Indian Sign Alphabet Recognition with Landmark Approach and Sequence Decoding" },
    { id: 199, title: "HISAB: An In-the-Wild Indian Receipt Dataset for Document Image Understanding" },
    { id: 201, title: "NrityaNirmiti: Diffusion-Driven Video Generation with Pose-Directed Movements" },
    { id: 202, title: "Edge AI: Real-Time YOLOv5 Performance Analysis on Embedded CPU and FPGA" },
    { id: 204, title: "Noise Removal from Ultrasound Images" },
    { id: 205, title: "Channel Attention-Based Lightweight Network for Plate Cleanliness Classification" },
    { id: 222, title: "Study of Explainability in Crop Classification Using Transformer Local Attention" },
    { id: 223, title: "Attention-Enhanced Deep Learning for Multi-Species Pollen Grain Classification using Microscopic Imaging" },
    { id: 226, title: "Federated Aerial Person Re-Identification with Camera-Aware Adaptive Margin Learning" },
    { id: 228, title: "Multimodal Retrieval-Augmented AI Assistant for Human Spaceflight Operations" },
    { id: 232, title: "HyperSaltNet: An Attention-Driven Hybrid Deep Learning Framework for Microplastics Detection in Edible Salt Using Hyperspectral Data" },
    { id: 240, title: "IndoLepAtlas: A Fine-Grained Dataset of Indian Lepidoptera with Geotemporal Metadata and Baseline Classification Study" },
    { id: 251, title: "CompostVision: A Deep Learning Framework for Compost Image Classification and Crop Suitability Prediction" },
    { id: 253, title: "Scene-Aware Ownership and Intent Breakdown Detection (SOID)" },
    { id: 257, title: "FDA-UIE: Frequency and Difficulty-Aware Underwater Image Enhancement" },
    { id: 259, title: "End-To-End Segmentation And Recognition Of Handwritten Text In Bank Challans" },
    { id: 260, title: "DeityNet: Recognition of stone sculptures of deities using deep learning" },
    { id: 261, title: "Ensemble Deep Learning for Consumer Purchase Prediction from Scalp EEG Signals" },
    { id: 263, title: "Knowledge-Graph Enhanced Multimodal Fusion for Chest Disease Detection" },
    { id: 265, title: "Design of a Natural Scene Assamese Text Recognition System" },
    { id: 269, title: "Automated Wood Species Classification Using Hyperspectral Imaging and Machine Learning" },
    { id: 270, title: "Framelet Based a Non-convex Fractional Order TV Model for Image Restoration Using ADMM Technique" },
    { id: 271, title: "Learning Label-Efficient Representations for Photovoltaic Fault Detection via Contrastive and Foundation Model Feature Fusion" },
    { id: 272, title: "Adaptive Frequency-Aware Perceptual Learning for Robust Zero-Shot Low-Light Image Enhancement" },
    { id: 273, title: "DenseNet201-Anchored Neurosymbolic Graph Transformer for Multi-Class Colorectal Cancer Classification from Histopathological Images" },
    { id: 275, title: "Super-Resolution Guided Multi-Modal Deep Learning System for Suspicious Person Recognition" },
    { id: 277, title: "Beyond Similarity: Source-Aware Retrieval for Classical Tamil Twin Epics" },
    { id: 280, title: "PDSTA: A Gated Parallel Spatio-Temporal Attention Network for Real-Time Home Rehabilitation Monitoring" },
    { id: 288, title: "A Benchmark Dataset and Attention-Enhanced ConvNeXt Framework for Fine-Grained Herbal Material Classification" }
  ];

  return (
    <div className="page-container">
      <PageCarousel />

      <section className="section-padding bg-light py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              
              {/* Page Title Section */}
              <div className="text-center mb-5">
                <h1 className="fw-bold mb-2" style={{ color: '#002147' }}>Paper Presentations</h1>
                <p className="text-muted">List of accepted papers for NCVPRIPG 2026</p>
              </div>

              {/* Main Card Container */}
              <div className="card shadow-sm border-0 rounded-4 overflow-hidden p-4 bg-white">
                
                {/* Total Counter Badge */}
                <div className="mb-4 text-end">
                  <span className="badge bg-success p-2 fs-6">
                    Total Accepted Papers: {papersList.length}
                  </span>
                </div>

                {/* Papers Table */}
                <div className="table-responsive">
                  <table className="table table-hover align-middle border">
                    <thead style={{ background: '#70b60a', color: '#ffffff' }}>
                      <tr>
                        <th scope="col" className="py-3 px-4 text-center" style={{ width: '120px' }}>
                          Paper ID
                        </th>
                        <th scope="col" className="py-3 px-4">
                          Paper Title
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {papersList.map((paper, index) => (
                        <tr key={paper.id} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fbf7' }}>
                          <td className="fw-bold text-center py-3 px-4" style={{ color: '#002147' }}>
                            #{paper.id}
                          </td>
                          <td className="py-3 px-4 fw-medium text-dark" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                            {paper.title}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Papers;